import React, { useState } from "react";
import { Copy, RefreshCw, KeyRound } from "lucide-react";
import { toast } from "sonner";
import { api, apiError } from "../api";
import { useLang } from "../i18n";
import { Button } from "./ui/button";
import {
  AlertDialog, AlertDialogContent, AlertDialogHeader, AlertDialogFooter,
  AlertDialogTitle, AlertDialogDescription, AlertDialogAction, AlertDialogCancel,
} from "./ui/alert-dialog";

export function InviteCodeBar({ tenant, onChanged }) {
  const { t } = useLang();
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);
  if (!tenant?.invite_code) return null;

  const copy = async () => {
    try { await navigator.clipboard.writeText(tenant.invite_code); toast.success(t("admin_copied")); }
    catch { toast.error(tenant.invite_code); }
  };
  const regenerate = async () => {
    setBusy(true);
    try {
      const r = await api.post(`/admin/tenants/${tenant.slug}/invite-code`);
      onChanged?.(r.data.invite_code);
    } catch (e) { toast.error(apiError(e.response?.data?.detail) || e.message); }
    finally { setBusy(false); setOpen(false); }
  };

  return (
    <div className="flex flex-wrap items-center gap-3 mb-6 rounded-2xl bg-white border border-stone-200 px-4 py-3" data-testid="invite-code-bar">
      <KeyRound className="w-4 h-4 text-[#3F6E85]" />
      <span className="text-sm text-[#6E6B65]">{t("admin_invite_code")}:</span>
      <code className="font-mono text-base tracking-[0.2em] text-[#2B4A59]" data-testid="invite-code-value">{tenant.invite_code}</code>
      <Button size="sm" variant="outline" onClick={copy} className="rounded-full gap-1.5" data-testid="invite-code-copy">
        <Copy className="w-3.5 h-3.5" /> {t("admin_copy")}
      </Button>
      <Button size="sm" variant="outline" onClick={() => setOpen(true)} disabled={busy} className="rounded-full gap-1.5" data-testid="invite-code-regenerate">
        <RefreshCw className="w-3.5 h-3.5" /> {t("admin_regenerate")}
      </Button>
      <AlertDialog open={open} onOpenChange={setOpen}>
        <AlertDialogContent data-testid="invite-code-confirm">
          <AlertDialogHeader>
            <AlertDialogTitle>{t("admin_regenerate")}</AlertDialogTitle>
            <AlertDialogDescription>{t("admin_regenerate_confirm")}</AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel data-testid="invite-code-confirm-cancel">{t("cancel")}</AlertDialogCancel>
            <AlertDialogAction onClick={regenerate} className="bg-[#3F6E85] hover:bg-[#2B4A59] text-white" data-testid="invite-code-confirm-ok">{t("admin_regenerate")}</AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </div>
  );
}
